import { registerEmailInKlaviyo } from "../services/klaviyo";
import { $Q } from "./query-selector";

export const getLang = (email) => {
  let lang = $Q("html").getAttribute("lang");
  registerEmailInKlaviyo(email, lang);
}
